import { render, staticRenderFns } from "./TransactionExternalReferenceOverlay.vue?vue&type=template&id=0089b5b4&scoped=true&"
import script from "./TransactionExternalReferenceOverlay.vue?vue&type=script&lang=ts&"
export * from "./TransactionExternalReferenceOverlay.vue?vue&type=script&lang=ts&"
import style0 from "./TransactionExternalReferenceOverlay.vue?vue&type=style&index=0&id=0089b5b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0089b5b4",
  null
  
)

export default component.exports